import { datadogRum } from '@datadog/browser-rum'
import { addReactError } from '@datadog/browser-rum-react'
import { ErrorInfo } from 'react'
import uncaught from 'uncaught'

const caughtErrors = new Set<Error>([])
let errorReceiver: (error: Error) => void | undefined

/**
 * Triggers the ErrorBoundary error manually, the component needs to setup the receiver to the instance
 */
export const setupErrorReceiver = (receiver: (error: Error) => void) => (errorReceiver = receiver)

export const catchError = (err: Error, info?: ErrorInfo) => {
  // Prevent the same error being reported twice
  if (caughtErrors.has(err)) return
  caughtErrors.add(err)

  // Log error as React error if we have an ErrorInfo
  if (info) addReactError(err, info)
  else datadogRum.addError(err)

  // Trigger ErrorBoundary to display the error

  // TODO: Remove comment when there are no harmless unhandled errors
  // if (errorReceiver) errorReceiver(err)
}

uncaught.start()
uncaught.addListener(err => catchError(err))
